var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.changeView,{tag:"component",attrs:{"change":_vm.change,"label":_vm.label,"action":_vm.action,"schema":_vm.schema}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }